import React,{ useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import Top_Cities_list_One from "../../assests/images/top-cities-images/cities-img-1.svg";
import Top_Cities_list_Two from "../../assests/images/top-cities-images/cities-img-2.svg";
import Top_Cities_list_Three from "../../assests/images/top-cities-images/cities-img-3.svg";
import Top_Cities_list_Four from "../../assests/images/top-cities-images/cities-img-4.svg";

import {
    TopCitiesNonProfitsWrap,
    TopCausesSection,
    TopCitiesSection,
    TopCitiesListBox,
    TopCitiesImageBox,
} from "./citiesStyle";
import { Title,
    WriteReviewSection,
    ReviewText, 
    ReviewRightSection,
    RightBanner,
} from "../../components/common/commonSubBanner/commonSubBannerStyle";
import ReviewImage from '../../assests/images/top-banner-image/get-badge-image.webp';
import { CitiesBox, CitiesBoxSubTitle, CityNameList } from "../../components/common/issueGrid/issueGridStyle";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { topCitiesHandler } from "../../redux/slices/donationCamp/topCities-slice";
import { TopCityProps } from "../../utils/types";
import SimpleLoader from "../../components/common/simpleLoader/Loader";
import MetaComponent from "../../components/common/metaComponent";

const TopCities = () => {
        const navigate = useNavigate(); 
        const dispatch = useDispatch();
        const topCitiesData = useSelector((state: TopCityProps) => state?.topCities?.data?.results);
        const [loader,setLoader] = useState(false);

        useEffect(()=>{
            setLoader(false); 
        },[topCitiesData])
    
        useEffect(() => {
            dispatch(topCitiesHandler() as any);
            setLoader(true);
        }, [dispatch]);
    
        const images = [{
                id: 1,
                src: Top_Cities_list_One,
                alt: "top cities list One"
            }, {
                id: 2,
                src: Top_Cities_list_Two,
                alt: "top causes list Two"
            }, {
                id: 3,
                src: Top_Cities_list_Three,
                alt: "Top cities list Three"
            }, {
                id: 4,
                src: Top_Cities_list_Four,
                alt: "top cities list Four"
            }
        ];


    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle=""
            ogDescription=""
            ogUrl=""
            ogImage=""
        />
    <>
    <TopCitiesNonProfitsWrap>
        <TopCausesSection >
            <WriteReviewSection className="top-cities-banner">
                <Container className="cont-w"> 
                    <Row>
                        <Col lg={6} sm={12} md={12}>
                            <Title className="page-main-heading">Find Nonprofits & Charities in Popular Cities</Title>
                            <ReviewText className="review-content-p">Want to donate to or volunteer for a charity or nonprofit? Find top-rated nonprofits and charities, see ratings and reviews, and start volunteering or donating today. </ReviewText>
                            <ReviewText className="review-content-p">Browse nonprofits and charities by <Button onClick={() => navigate("/about/cities")}>state</Button>. Or search for nonprofits and charities by <Button onClick={() => navigate("/navigation/issues")}>category and cause</Button>. </ReviewText>
                        </Col>
                        <Col lg={6} sm={12} md={12}>
                            <RightBanner className="left_banner">
                                <ReviewRightSection>
                                    <Image src={ReviewImage} alt="ReviewImage"/>
                                </ReviewRightSection>
                            </RightBanner>
                        </Col>
                    </Row>
                </Container>
            </WriteReviewSection>
        </TopCausesSection> 
    </TopCitiesNonProfitsWrap>

        <TopCitiesSection>
            <Container className="cont-w">
                <Row>
               
                    <Col sm="12" className="top-city-count">
                    {loader? <div className="loader-cities"><SimpleLoader/></div>:<>
                    {topCitiesData?.map((topCity:any, index:any) => ( 
                            <React.Fragment key={index+1}>
                                <TopCitiesListBox>
                                    <CitiesBox>
                                        <CitiesBoxSubTitle onClick={() => navigate(`/state/${topCity?.state?.name}`)}>
                                            {topCity?.state?.name}
                                        </CitiesBoxSubTitle>
                                        {topCity?.cities.map((city:any, index:number) => (
                                            <CityNameList className="city-name-list" key={index+1} onClick={() => navigate(`/city/${city?.slug}/${city?.state}`,{state:{stateFullName:topCity?.state?.name,zipcodeAdd:city?.zipcode}})}>
                                                {city?.name}
                                            </CityNameList>
                                        ))}
                                    </CitiesBox>
                                </TopCitiesListBox>
                                {(index + 1) % 5 === 0 && images[(index + 1) / 5 - 1] && (
                                    <TopCitiesImageBox key={`image-${index+1}`}>
                                        <Image src={images[(index + 1) / 5 - 1].src} alt={images[(index + 1) / 5 - 1].alt} />
                                    </TopCitiesImageBox>
                                )}
                            </React.Fragment>
                        ))}
                    </>}
                        
                    </Col>
                </Row>
            </Container>
        </TopCitiesSection>

    </></>)
};
export default TopCities;